import { useStrictLocalization } from "@faire/web/common/localization";
import {
  formatMoney,
  moneyOrZero,
  RoundingStrategy,
} from "@faire/web/common/money";

import { bpsToPercentString } from "@faire/retailer/lib/bpsUtils";

import { useFirstOrderIncentiveStore } from "./useFirstOrderIncentiveStore";

export const useFirstOrderIncentiveFormattedData = () => {
  const { strictLocalize } = useStrictLocalization();
  const { formattedIncentiveData: incentiveData } =
    useFirstOrderIncentiveStore();

  const {
    incentiveAmount,
    incentiveMinimum,
    incentiveBps,
    incentiveMaxOfferAmount,
  } = incentiveData;

  const formattedIncentiveAmount = formatMoney({
    money: moneyOrZero(incentiveAmount),
    roundingStrategy: RoundingStrategy.DROP_CENTS,
  });

  const formattedIncentivePercent = bpsToPercentString(
    incentiveBps ?? 0,
    strictLocalize
  );

  const formattedIncentiveMinimum = formatMoney({
    money: moneyOrZero(incentiveMinimum),
    roundingStrategy: RoundingStrategy.DROP_CENTS,
  });

  const formattedIncentiveMaxOfferAmount = formatMoney({
    money: moneyOrZero(incentiveMaxOfferAmount),
    roundingStrategy: RoundingStrategy.DROP_CENTS,
  });

  return {
    formattedIncentivePercent,
    formattedIncentiveAmount,
    formattedIncentiveMinimum,
    formattedIncentiveMaxOfferAmount,
  };
};
